var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"h-img",attrs:{"src":_vm.srcComputed},on:{"click":_vm.onclick}})
}
var staticRenderFns = []

export { render, staticRenderFns }